<div #visualObjectContainer>
  <floating [floatingPosition]="decoration.floatingPosition">
    <div class="visual-object-margin header-decoration" [style.max-width]="width" >
      <span class="{{classes}}">{{decoration.title}}</span>
      <hr />
    </div>
  </floating>
</div>